import React, { useEffect } from 'react';
import { Button } from "./components/ui/button"
import { GlobeIcon } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./components/ui/dropdown-menu"

const languages = [
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'en', name: 'English', flag: '🇬🇧' }
];

const LanguageSelector = ({ currentLanguage, onLanguageChange }) => {
  useEffect(() => {
    // Check browser language preferences
    const browserLang = navigator.language.split('-')[0];
    if (!currentLanguage && languages.some(lang => lang.code === browserLang)) {
      onLanguageChange(browserLang);
    }
  }, []);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="flex items-center gap-2">
          <GlobeIcon className="h-4 w-4" />
          <span>{languages.find(l => l.code === currentLanguage)?.name || 'Language'}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => onLanguageChange(lang.code)}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span>{lang.flag}</span>
            <span>{lang.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default LanguageSelector;